import { render, staticRenderFns } from "./dataManage.vue?vue&type=template&id=51f5e273&scoped=true&"
import script from "./dataManage.vue?vue&type=script&lang=js&"
export * from "./dataManage.vue?vue&type=script&lang=js&"
import style0 from "./dataManage.vue?vue&type=style&index=0&id=51f5e273&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5e273",
  null
  
)

export default component.exports